module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container4"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/London_SouthSea-scan01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center_t"
  }, [_vm._v("“W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HENEVER")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THINK OF MYSELF,")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SHALL THINK OF YOU.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HENEVEK MEN CALL ME BY NAME,")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SHALL THINK OF YOU.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S IT WELL, MASTEK?")]), _vm._v("”"), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759e2e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 66
// module chunks = 0